import React, { memo } from "react";
import { Button, Card, Row, Col } from "react-bootstrap";
import "./OrderSummary.scss";

const OrderSummary = ({
  subscriptionsData,
  totalAmount,
  onCompletePayment,
  loading,
  selectedPricingOptions,
  selectedBank,
}) => {
  if (!subscriptionsData || subscriptionsData.length === 0) {
    return <div>Loading...</div>;
  }
  let selectedOption;

  const formatOptionLabel = (option) => {
    switch (option.pricingModel) {
      case "Hourly Plan":
        return `${option.hours} Hours @ ${option.currency || 'AED'} ${option.perHourPrice}/hour`;
      case "Free Plan":
        return "Free";
      default:
        const days = option.validity || 30;
        const months = Math.floor(days / 30);
        const remainingDays = days % 30;
        let label = "";
        if (months > 0) label += `${months} month${months > 1 ? "s" : ""} `;
        if (remainingDays > 0)
          label += `${remainingDays} day${remainingDays > 1 ? "s" : ""}`;
        return label.trim();
    }
  };

  const calculateOptionPrice = (option) => {
    if (option.pricingModel === "Hourly Plan") {
      const pricePerHour = parseFloat(option.perHourPrice || 0);
      const hours = parseFloat(option.hours || 0);
      const discount = parseFloat(option.discount || 0);
      return (pricePerHour * hours * (1 - discount / 100)).toLocaleString();
    }
    return (
      option.finalPrice || option.price * (1 - (option.discount || 0) / 100)
    ).toLocaleString();
  };

  return (
    <Card className="order-summary-card">
      <Card.Body>
        <Card.Title className="mb-3">Your Order Summary</Card.Title>

        {subscriptionsData.map((subscriptionData) => {
          selectedOption =
            selectedPricingOptions[subscriptionData._id] ||
            subscriptionData.applicableOptions[0];
          if (!selectedOption) return null;

          const finalPrice = calculateOptionPrice(selectedOption);
          const originalPrice =
            selectedOption.pricingModel === "Hourly Plan"
              ? (
                  selectedOption.perHourPrice * selectedOption.hours
                ).toLocaleString()
              : selectedOption.price.toLocaleString();

          return (
            <Row
              key={subscriptionData._id}
              className="order-summary-item align-items-center mb-3"
            >
              <Col xs={8}>
                <div className="item-description">
                  <span className="item-title">
                    {subscriptionData.name} -{" "}
                    {formatOptionLabel(selectedOption)}
                  </span>
                  {selectedOption.discount > 0 && (
                    <div className="item-discount mt-1">
                      <del className="original-price">
                        {selectedOption.currency ||
                          subscriptionData.currency.toUpperCase()}{" "}
                        {originalPrice}
                      </del>
                      <span className="discount-text">
                        {selectedOption.discount}% OFF
                      </span>
                    </div>
                  )}
                </div>
              </Col>
              <Col xs={4} className="text-end">
                <span className="price">
                  {selectedOption.currency ||
                    subscriptionData.currency.toUpperCase()}{" "}
                  {finalPrice}
                </span>
              </Col>
            </Row>
          );
        })}

        <hr className="my-3" />

        {/* Payment Gateway Display */}
        {selectedBank && (
          <div className="payment-gateway-info mb-3 p-3" style={{
            background: 'linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%)',
            borderRadius: '10px',
            border: '1px solid #e8e8e8'
          }}>
            <div className="d-flex align-items-center gap-2">
              <i className="fas fa-credit-card" style={{ color: '#667eea', fontSize: '1.25rem' }}></i>
              <div>
                <small style={{ fontSize: '0.75rem', color: '#6b7280', display: 'block' }}>
                  Payment Method
                </small>
                <strong style={{ fontSize: '0.875rem', color: '#1a1a1a' }}>
                  Credit/Debit Card
                </strong>
              </div>
            </div>
          </div>
        )}

        <Row className="total-section align-items-center mb-3">
          <Col xs={6}>
            <span className="total-label">Total:</span>
          </Col>
          <Col xs={6} className="text-end">
            <span className="total-amount">
              {selectedOption.currency ||
                subscriptionsData[0].currency.toUpperCase()}{" "}
              {totalAmount.toLocaleString()}
            </span>
          </Col>
        </Row>

        <div className="d-grid">
          <Button
            className="complete-payment-button"
            onClick={onCompletePayment}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Processing...
              </>
            ) : (
              <>
                <i className="fas fa-lock me-2"></i>
                Complete Payment
              </>
            )}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default memo(OrderSummary);
